/**
 * Loader : Site loader if half images are not loaded
 */
import { TweenMax, TimelineLite, Expo, Power2, Power3, Power4 } from 'gsap';

// Élements & Variables
const html = document.querySelector('html');
const body = document.body;
const loader = document.querySelector('.js-loader');
const loaderProgresses = loader.querySelectorAll('.loader__progress');
const loaderBackground = loader.querySelector('.loader__background');
const loaderContainer = loader.querySelector('.loader__container');
const loaderLogo = loader.querySelector('.loader__logo');
const siteWrapper = document.querySelector('.site-wrapper');
const allImages = body.querySelectorAll('img');

// Init Loader
if (allImages.length) {
  const imagesCount = allImages.length;
  let imagesLoadedCount = 0;

  allImages.forEach((image) => {
    if (image.complete && image.naturalHeight !== 0) {
      imagesLoadedCount++;
    }
  });

  if (imagesLoadedCount >= Math.round(imagesCount / 2) && !body.classList.contains('path-frontpage')) {
    loader.classList.add('hide');
  } else {
    html.classList.add('is-loading');
    const loaderTL = new TimelineLite({
      onComplete: function () {
        html.classList.remove('is-loading');
        loader.classList.add('hide');
      }
    });

    loaderTL.add('start');
    loaderTL.add(TweenMax.staggerFromTo(loaderProgresses, 0.6, {scaleX: 0}, {
      scaleX: 1,
      ease: Expo.easeInOut
    }, 0.4), 'start+=0.5');
    loaderTL.add(TweenMax.fromTo(loaderLogo, 0.6, {opacity: 0}, {opacity: 1, ease: Power2.easeIn}), 'start+=1.25');
    loaderTL.add('logoAppears');
    loaderTL.add(TweenMax.to(loaderContainer, 0.75, {opacity: 0, ease: Power2.easeOut}), 'logoAppears+=0.5');
    loaderTL.add('logoFadingOut');
    loaderTL.add(TweenMax.to(loaderBackground, 0.9, {scaleX: 0, ease: Power4.easeInOut}), 'logoFadingOut-=0.25');
    loaderTL.add(TweenMax.fromTo(siteWrapper, 0.75, {opacity: 0}, {
      opacity: 1,
      ease: Power3.easeOut
    }), 'logoFadingOut+=0.1');
  }
} else {
  loader.classList.add('hide');
}
